import { RootState } from 'store/rootReducer';
import { getSimpleDataSelector } from '@cp-shared-19/frontend-integration';

export const ContractsDataSelector = getSimpleDataSelector((state: RootState) => state.contracts);
